var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLangEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 182 182",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "e",
    cx: 90,
    cy: 90,
    r: 90,
    fill: "#346da6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m163.36 37.852c-2.9159-4.0947-6.1661-7.9349-9.7107-11.481l-0.02174-0.02174c-3.5458-3.5446-7.386-6.7948-11.481-9.7107l-125.51 125.51c2.9159 4.0947 6.1661 7.9349 9.7107 11.481l0.02174 0.02174c3.5458 3.5446 7.386 6.7948 11.481 9.7107z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m142.15 163.36c4.0947-2.9159 7.9349-6.1661 11.481-9.7107l0.02174-0.02174c3.5446-3.5458 6.7948-7.386 9.7107-11.481l-125.51-125.51c-4.0947 2.9159-7.9349 6.1661-11.481 9.7107l-0.02174 0.02174c-3.5446 3.5458-6.7948 7.386-9.7107 11.481z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ca4638"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 -1 0 180)",
    d: "m160.29 33.784c-2.0894-2.609-4.3211-5.0992-6.6833-7.4588l-63.202 63.202 7.0711 7.0711z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-1-copy-10",
    transform: "matrix(1 0 0 -1 0 180)",
    d: "m33.784 19.713c-2.609 2.0894-5.0992 4.3211-7.4588 6.6833l68.202 68.202 7.0711-7.0711z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    transform: "matrix(1 0 0 -1 0 180)",
    d: "m146.22 160.29c2.609-2.0894 5.0992-4.3211 7.4588-6.6833l-58.202-58.202-7.0711 7.0711z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 -1 0 180)",
    d: "m19.713 146.22c2.0894 2.609 4.3211 5.0992 6.6833 7.4588l57.202-57.202-7.0711-7.0711-56.814 56.814z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m178.76 105c0.81839-4.8781 1.2444-9.8893 1.2444-15s-0.42598-10.122-1.2444-15h-177.51c-0.81839 4.8781-1.2444 9.8893-1.2444 15s0.42598 10.122 1.2444 15z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105 178.76c-4.8781 0.81839-9.8893 1.2444-15 1.2444s-10.122-0.42598-15-1.2444v-177.51c4.8781-0.81839 9.8893-1.2444 15-1.2444s10.122 0.42598 15 1.2444z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m179.45 100c0.36296-3.2833 0.54929-6.6199 0.54929-10s-0.18633-6.7167-0.54929-10h-178.9c-0.36295 3.2833-0.54929 6.6199-0.54929 10s0.18633 6.7167 0.54929 10z",
    fill: "#ca4638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100 179.45c-3.2833 0.36296-6.6199 0.54929-10 0.54929s-6.7167-0.18633-10-0.54929v-178.9c3.2833-0.36295 6.6199-0.54929 10-0.54929s6.7167 0.18633 10 0.54929z",
    fill: "#ca4638"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangEn);
export default __webpack_public_path__ + "static/media/lang-en.d0421582a8510a2dbf8204df92d1adea.svg";
export { ForwardRef as ReactComponent };